const nl = {
  translation: {
    salutation: "hallo",
    introduction: "ik ben",
    introudction_job_title: "en ik ben een",
    developer: "ontwikkelaar",
    download: "download",
    cv: "CV",
    select: "selecteer",
    experiance_years: "{{years}} jaar",
    of_experiance: "ervaring",
    my_portofolio: "mijn portfolio",
    portofolio: "portfolio",
    testimonials: "getuigenissen",
    all: "alle",
    about: "over",
    skill_level_question: "wat is mijn vaardigheidsniveau",
    see_more: "bekijk meer",
    achievements: "prestaties",
    personal_info: "persoonlijke informatie",
    experience: "Ervaring",
    education: "Opleiding",
    skills_and_technology: "vaardigheden en technologie",
    hide: "verbergen",
    get_in_touch: "contact opnemen",
    send_message: "bericht verzenden",
    message: "bericht",
    subject: "onderwerp",
    your_name: "jouw naam",
    email_address: "e-mailadres",
    talk_statment: "Laten we over alles praten",
    like_form_question: "houd niet van formulieren",
    send_me: "stuur me een",
    email: "e-mail",
    language: "taal",
    home_page: "home pagina",
    me: "ik",
    my_experience: "mijn ervaring",
    coming_soon: "binnenkort beschikbaar",
    this_page_is_under_construction: "deze pagina is in aanbouw",
    is_required_field: "{{field}} is verplicht veld",
  },
};

export default nl;
